import { Component, inject } from '@angular/core';
import { QrCodeComponent } from 'ng-qrcode';
import { ResponsiveService } from '../../services/responsive-service';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-connection-code',
  imports: [QrCodeComponent, NgClass, TranslateDirective],
  template: `
    <div class="code-block" [ngClass]="responsiveService.breakpoint()">
      <qr-code [size]="qrCodeSize" [value]="code || ''" errorCorrectionLevel="H" />
      <span translate>common.separator.or</span>
      <div class="text-code">
        <p translate>pages.connection.code</p>
        <p (click)="copyCode()" class="code" >{{ code }}</p>
      </div>
    </div>
  `,
  styleUrl: './connection-code.scss',
})
export class ConnectionCode {
  public readonly responsiveService: ResponsiveService = inject(ResponsiveService);
  protected readonly code: string | null = localStorage.getItem('connectionCode');

  async copyCode(): Promise<void> {
    if (!this.code) {
      console.error('No code error.')
      return
    };
    await navigator.clipboard.writeText(this.code);
  }

  get qrCodeSize(): number {
    switch (this.responsiveService.breakpoint()) {
      case 'large':
        return 200;
      case 'xlarge':
        return 250;
      default:
        return 150;
    }
  }
}
